export const TRAVELER_DEFAULT_BUTTON_STATES = {
  adultsMinusButtonDisabled: true,
  adultsPlusButtonDisabled: false,
  childrenMinusButtonDisabled: true,
  childrenPlusButtonDisabled: false,
  babiesMinusButtonDisabled: true,
  babiesPlusButtonDisabled: false,
};
